import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import React from "react";
import routeConstants from "utils/routeConstants";

const links: SectionLandingLink[] = [
  {
    title: "API documentation",
    to: routeConstants.apiDocs,
    description:
      "Elexon Insights Solution API Documentation is a comprehensive self service area for developers and Elexon data users to discover our " +
      "published API endpoints. You can access technical documentations, schemas and standard definitions such as Open API, WADL and codes.",
  },
  {
    title: "Insights Real-Time Information Service",
    to: routeConstants.iris,
    description:
      "IRIS is a near real-time, free, publicly available push service for accessing Insights Solution data. View the publicly accessible archive " +
      "or create an account to get access within minutes.",
  },
];

const DataServices: React.FC = () => (
  <SectionLandingPage
    title="Data Services"
    description={
      <>
        <p>
          This section contains links to the Insights solution API documentation
          as well as to the Insights real-time information service (IRIS).
        </p>
      </>
    }
    links={links}
  />
);

export default DataServices;
